export default __webpack_public_path__ + "static/media/event_info_bannerlogo.4095f809.png";